import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "../notification.module.css";

export default function Badge({
  icon,
  label,
  color = "#fff",
  backgroundColor = "#000",
}) {
  return (
    <span
      className={styles.badge}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "4px 8px",
        fontSize: "10px",
        borderRadius: "4px",
        color,
        backgroundColor,
      }}
    >
      {icon && <FontAwesomeIcon icon={icon} style={{ color }} />}
      {label}
    </span>
  );
}
